module.exports = __webpack_public_path__ + "static/bilal-akkaya-5927502fa191e69087eef5408549ecbd.jpg";